import { render, staticRenderFns } from "./OrdersInfoDialog.vue?vue&type=template&id=5462ed4a&scoped=true"
import script from "./OrdersInfoDialog.vue?vue&type=script&lang=js"
export * from "./OrdersInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./OrdersInfoDialog.vue?vue&type=style&index=0&id=5462ed4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5462ed4a",
  null
  
)

export default component.exports